import React from 'react'
import {Icon} from 'semantic-ui-react'
import { topbarMenu } from './styles.module.scss'


export default function TopBarRight({ logout }) {
  return (
    <ul className={topbarMenu}>
      <li>
        <Icon
          name="search"
          size="large"
        />
      </li>
      <li>
        <Icon
          name="bell"
          size="large"
        />
      </li>
      <li>
        <Icon
          name="setting"
          size="large"
        />
      </li>
      <li>
        <Icon
          name="user"
          size="large"
          title={"Logout"}
          onClick={logout}
        />
      </li>
    </ul>
  )
}